import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  CHECK_CODE,
  CHECK_CODE_SUCCESS,
  CHECK_CODE_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  LOGOUT_USER,
} from '../actions';
import { getCurrentUser } from '../../helpers/Utils';

const INIT_STATE = {
  currentUser: getCurrentUser(),
  forgotUserMail: '',
  checkCodeResponse: '',
  newPassword: '',
  loading: false,
  loadingFP: false,
  loadingCC: false,
  loadingRP: false,
  error: '',
  errorFP: '',
  errorCC: '',
  errorRP: null,
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: null };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
      };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: action.payload.message,
      };
    case FORGOT_PASSWORD:
      return { ...state, loadingFP: false };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loadingFP: true,
        forgotUserMail: action.payload,
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loadingFP: true,
        errorFP: action.payload.message,
        forgotUserMail: '',
      };

    case CHECK_CODE:
      return { ...state, loadingCC: false };
    case CHECK_CODE_SUCCESS:
      return {
        ...state,
        loadingCC: true,
        checkCodeResponse: action.payload,
      };
    case CHECK_CODE_ERROR:
      return {
        ...state,
        loadingCC: true,
        errorCC: action.payload,
      };

    case RESET_PASSWORD:
      return { ...state, loadingRP: false };
    case RESET_PASSWORD_SUCCESS:
      return { ...state, loadingRP: true, newPassword: action.payload };
    case RESET_PASSWORD_ERROR:
      return { ...state, loadingRP: true, errorRP: action.payload };

    case LOGOUT_USER:
      return { ...state, currentUser: null, error: '' };

    default:
      return { ...state };
  }
};

export default reducer;
